import { render, staticRenderFns } from "./WebinarViewDetails.vue?vue&type=template&id=42c30cb8&scoped=true&"
import script from "./WebinarViewDetails.vue?vue&type=script&lang=ts&"
export * from "./WebinarViewDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WebinarViewDetails.vue?vue&type=style&index=0&id=42c30cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c30cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VCol,VDivider,VIcon,VImg,VRow,VSheet})
